import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { NavLink } from 'react-router-dom';
import AppConfig from '../../appConfig';
import ClickOutside from '../common/clickOutside';

const NavbarAuthButtons = () => {
    const { user, logout } = useAuth0();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleLogout = () => {
        setDropdownOpen(false);
        localStorage.removeItem('userId');
        logout({
            logoutParams: {
                returnTo: window.location.origin + (AppConfig.baseUrl || '/'),
            },
        });
    };

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const closeDropdown = () => setDropdownOpen(false);

    return (
        <ClickOutside onClickOutside={closeDropdown}>
            <div className="navbar-auth dropdown" style={{ position: 'relative', padding: '5px' }}>
                <button
                    type="button"
                    className="btn btn-default btn-sm d-flex align-items-center py-1 px-2"
                    onClick={toggleDropdown}
                    style={{
                        backgroundColor: 'transparent',
                        border: '1px solid rgba(255,255,255,0.3)',
                        color: '#fff',
                    }}
                    aria-expanded={dropdownOpen}
                    aria-haspopup="true"
                >
                    {user?.picture && (
                        <img
                            src={user.picture}
                            alt=""
                            className="rounded-circle img-thumbnail mr-2"
                            style={{ width: '36px', height: '36px', objectFit: 'cover', padding: 0, borderColor: 'rgba(255,255,255,0.4)' }}
                        />
                    )}
                    <span className="text-white small mr-1">{user?.email || user?.name || 'Account'}</span>
                    <i className="fa fa-caret-down" style={{ fontSize: '12px' }} />
                </button>
                {dropdownOpen && (
                    <div
                        className="dropdown-menu dropdown-menu-right show"
                        style={{
                            position: 'absolute',
                            right: 0,
                            top: '100%',
                            marginTop: '4px',
                            minWidth: '180px',
                            zIndex: 1050,
                        }}
                    >
                        <NavLink
                            to={AppConfig.baseUrl + 'Profile'}
                            className="dropdown-item"
                            activeClassName="active"
                            onClick={closeDropdown}
                        >
                            <i className="fa fa-user mr-2" aria-hidden="true" />
                            Profile
                        </NavLink>
                        <div className="dropdown-divider" />
                        <button
                            type="button"
                            className="dropdown-item"
                            onClick={handleLogout}
                        >
                            <i className="fa fa-sign-out mr-2" aria-hidden="true" />
                            Log off
                        </button>
                    </div>
                )}
            </div>
        </ClickOutside>
    );
};

export default NavbarAuthButtons;
